import { IAuth } from '../auth/authServiceFactory';
import { FetchService } from './fetch';

export const fetchServiceFactory = (auth: IAuth) => new FetchService(auth);
